export default "__VITE_ASSET__BZbYZTa0__"